import AuthDescriptorContext from "./Context"

export default AuthDescriptorContext.Provider
